import { FC } from "react";
import { useTranslation } from "react-i18next";

export const ProfileModalNoCompany: FC = () => {
  const { t } = useTranslation();

  return (
    <div data-e2e="profile-no-company-connected-container">
      <p>{t("general.NO_COMPANY_CONNECTED")}</p>
    </div>
  );
};
